var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  This content is under development.\n  "),_c('div',{staticClass:"actions"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v("Go back")])])])}
var staticRenderFns = []

export { render, staticRenderFns }